module.exports = __webpack_public_path__ + "media/flags/en-5f1b6391.gif";